var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('logout-account', {
    attrs: {
      "step": _vm.$enum.mine.LogoutStepEnum.Completed
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };